<template>
  <AkMultiSelect
    :value="modelValue"
    :has-error="!!errors.length"
    :label="attribute.label + ' '"
    :placeholder="attribute.inputHint || $t('product.attributes.multiselect.placeholder')"
    :no-elements-message="$t('product.attributes.multiselect.empty')"
    :options="attribute.options"
    :label-info="attribute.inputTip"
    tag-color="accent-alt"
    :errors="errors"
    @update:model-value="$emit('update:modelValue', $event)"
  />
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { AkMultiSelect } from '@ankorstore/design-system';
import { ProductTypeAttributes } from '../../types/product-type-attributes';

export default defineComponent({
  name: 'ProductTypeMultiselect',
  components: {
    AkMultiSelect,
  },
  props: {
    attribute: {
      type: Object as () => ProductTypeAttributes,
      required: true,
      default: () => ({}),
    },
    modelValue: {
      type: Array as PropType<string | number[]>,
      default: () => [],
    },
    errors: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:modelValue'],
});
</script>
